<dx-data-grid id="gridContainer" [dataSource]="dataSource" [remoteOperations]="false" [allowColumnReordering]="true"
    [rowAlternationEnabled]="true" [showBorders]="true" [noDataText]="isLoading ? 'Loading...' : 'No Data'"
    (onSelectionChanged)="onSelectionChanged($event)" [wordWrapEnabled]="true" [showBorders]="false"
    [allowColumnResizing]="true" columnResizingMode="'true'" (onRowClick)="rowClickHandler($event)"
    (onSaved)="onRowSaved($event)">
    <!-- <dxo-load-panel
    [enabled]="true">
  </dxo-load-panel> -->
    <dxo-row-dragging [allowReordering]="config.canReorder || false" [onReorder]="onReorder" [showDragIcons]="true"></dxo-row-dragging>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-selection selectAllMode="allPages" [showCheckBoxesMode]="checkBoxesMode" mode="multiple"></dxo-selection>

    <dxo-paging *ngIf="config.showPagination || config.paginationByApi" [pageSize]="defaultPageSize || 10"></dxo-paging>

    <dxo-pager *ngIf="config.showPagination?.showPageSizeSelector == true" [showPageSizeSelector]="config.showPagination != null"
        [allowedPageSizes]="config.showPagination?.allowedPageSizes || [10, 25, 50, 100]"></dxo-pager>

    <dxo-column-chooser [enabled]="config.columnChooser || false" mode="select">
    </dxo-column-chooser>

    <dxo-export [enabled]="config.exportData || false"></dxo-export>

    <dxo-search-panel [visible]="config.searchPanel" [highlightCaseSensitive]="false"></dxo-search-panel>

    <dxo-group-panel [visible]="config.groupPanel"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="config.expandGroup || false"></dxo-grouping>

    <dxo-filter-row [visible]="config.filterEnabled"></dxo-filter-row>

    <dxo-editing mode="row" [allowAdding]="config.canAdd || false" [allowUpdating]="config.canEdit || false">

    </dxo-editing>
    <ng-container *ngFor="let config of config.fields">
        <ng-container *ngIf="!config.hide">
            <dxi-column [width]="config.width || undefined" dataField="{{config.dataField}}"
                caption="{{config.caption}}" dataType="{{config.dataType || 'string'}}"
                format="{{config.format || null}}" alignment="{{ config.alignment || 'left' }}"
                cssClass="{{ config.cssClass || '' }}" [allowGrouping]="config.allowGrouping || false"
                cellTemplate="{{ config?.cellTemplate?.id || null }}" [groupIndex]="config.groupIndex || null">
                <ng-container *ngIf="config.combineDataField">
                    <ng-container *ngFor="let combine of config.combineDataField">
                        <dxi-column dataField="combine.dataField" caption="combine.caption"
                            dataType="config.dataType || 'string'" format="config.format || null"
                            alignment="config.alignment || 'left'" cssClass="config.cssClass || ''"
                            [allowGrouping]="config.allowGrouping || false" cellTemplate="config.cellTemplate || null"
                            [groupIndex]="config.groupIndex || null">
                        </dxi-column>
                    </ng-container>
                </ng-container>
            </dxi-column>
        </ng-container>

        <ng-container *ngIf="config.cellTemplate">
            <div *dxTemplate="let d of config.cellTemplate.id">
                <p *ngIf="config.cellTemplate.dataField">
                    {{ showDataField(d.data, config.cellTemplate.dataField) }}
                </p>

                <ng-container *ngIf="config.cellTemplate.dataImage">
                    <div class="text-center">
                        <img class="data-img" src="{{ showImageField(d.data, config.cellTemplate.dataImage) }}" />
                    </div>
                </ng-container>

                <ng-container *ngIf="config.cellTemplate.buttons">
                    <a *ngFor="let button of config.cellTemplate.buttons" (click)="emitAction(d.data, button)">
                        <ng-container *ngIf="button.condition == null || button.condition?.(d.data)">
                            <dx-button [class]="button.cssClass">
                                <i [class]="button.icon" *ngIf="button.icon; else buttonEle"></i>
                                <ng-template #buttonEle>{{button.name}}</ng-template>
                            </dx-button>
                        </ng-container>
                    </a>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</dx-data-grid>
<!-- 
    [ngClass]="{
              'data-edit': data === 'Edit',
              'data-delete': data === 'Delete',
              'data-download': data === 'Download',
              'data-view': data === 'View',
              'data-send': data === 'Send'
            }"
 -->

<!-- <ng-container *ngIf="config.paginationByApi && dataSource?.length > 0">
  <mat-paginator
    [length]="dataLength"
    [pageSize]="config.paginationByApi.pageSize"
    [pageSizeOptions]="config.paginationByApi.allowedPageSizes"
    (page)="emitPageEvent($event)"
    aria-label="Select page"
  >
  </mat-paginator>
</ng-container> -->